var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('thankyou_page'))+" "),_c('br'),_c('div',{staticClass:"btn link"},[_c('a',{on:{"click":_vm.logout}},[_vm._v(" Kirjaudu ulos ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }